import React, { useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { checkAuth } from '../lib/util/Authenticate';
import ModalContext from '../modules/contexts/Modalcontext';
import styled from 'styled-components';
import { Flex } from '../components/common/atom/Layout';
import { CheckIcon } from '../components/common/atom/Icon';
import { Text } from '../components/common/atom/Text';
import { EventDetailTemplateWithButtons } from '../components/common/template/EventDetailTemplate';
import * as PATH from '../lib/routes/path';
import * as api from '../lib/api/api';
import * as IMAGE from '../lib/image/event/EventMiraeassetImages';
import * as EVENT from '../domain/event/EventMiraeassetData';

const ConsentCheckbox = ({ checked, onClick, text }) => {
  const [isChecked, setisChecked] = useState(checked);
  const onCheckClicked = () => {
    setisChecked(!isChecked); 
    onClick(!isChecked);
  }
  return (
    <Flex onClick={onCheckClicked} style={{ cursor: 'pointer' }} >
      <CheckIcon
        defaultBackgroundColor="pinkishGrey"
        checked={isChecked}
      />
      <Text size={12} style={{ marginLeft: '0.5rem', lineHeight: 1.5 }}>{text}</Text>
    </Flex>
  );
}

const EventMiraeAssetDetailPage = () => {
  const history = useHistory();
  const { onModal, onCloseModal, setIsButtonAvailable } = useContext(ModalContext).actions;
  const [ consentChecked, setConsentChecked ] = useState(false);
  const [ ongoingEvents, setOngoingEvents ] = useState([]);

  useEffect(() => {
    api.getOngoingEvents().then((response) => {
      setOngoingEvents(response.data.filter(e => 
        e.code === 'MIRAEASSET_PARENT_ACCOUNT' || e.code === 'MIRAEASSET_CHILDREN_ACCOUNT'));
    });
  }, []);

  useEffect(() => {
    setIsButtonAvailable(consentChecked);
  }, [consentChecked]);

  const onClickEventButton = async (isFirstEvent) => {
    // 로그인 여부 확인
    if (!checkAuth()) {
      onModal({
        title: '로그인 안내',
        content: (<ModalText>이벤트 참여를 위해서는 베이비페이스 로그인이 
          필요합니다. 로그인 하시고 이벤트에 참여해 보세요!</ModalText>),
        buttonText: '로그인하기',
        afterConfirmEvent: () => history.push(PATH.SIGNIN),
      });
      return;
    }

    // 이벤트 응모 후 실행할 로직
    const afterEventApplied = (eventParticipantId) => {
      if (isFirstEvent) {
        window.open(`https://api.pincrux.com/click.pin?appkey=139149&pubkey=911713&cruxkey=${eventParticipantId}`, '_blank');
      } else {
        onModal({
          title: '자녀 계좌 개설',
          content: (<ModalText size={12}>
            자녀 첫 계좌 이벤트 신청을 완료하고, M-STOCK 앱에서 자녀 계좌 개설하면, 베이비페이스 베이직 가격(35,000원)의 50% 환불이 처리됩니다.<br />
            <b>M-STOCK 앱설치 - 왼쪽하단 메뉴 - 서비스 - 계좌개설 - 미성년자녀 - 자녀계좌개설</b></ModalText>),
          afterConfirmEvent: () => { window.open('https://securities.miraeasset.com/mobilew/app/AppLink.jsp?An=nms&Al=event&Am=evnno:202403011', '_blank'); }
        });
      }
    }

    // 계정관리로 넘어가기 위한 로직
    const toUserInfo = () => {
      window.open(PATH.MYPAGE_ACCOUNT, '_blank');
      onCloseModal();
    }

    try {
      // 유저 정보 확인
      const userInfo = (await api.getInfo()).data;

      // 휴대폰 번호가 없는 경우 팝업 안내
      if (!userInfo.contactInfo || userInfo.contactInfo.mobile === '') {
        onModal({
          title: '이벤트 안내',
          content: (<ModalText>본 이벤트를 참여하기 위해서는 휴대폰 번호가 필요합니다.<br />
            "<LinkText onClick={toUserInfo}>계정관리 (새창)</LinkText>"에서 입력해 주세요.<br />
          </ModalText>),
          buttonText: '확인',
        });
        return;
      }

      const name = userInfo.name;
      const mobile = userInfo.contactInfo.mobile;

      // 이벤트 정보 확인 및 이미 참여한 이벤트인지 여부 확인
      const firstEventId = ongoingEvents.find(e => e.code === 'MIRAEASSET_PARENT_ACCOUNT').id;
      const secondEventId = ongoingEvents.find(e => e.code === 'MIRAEASSET_CHILDREN_ACCOUNT').id;
      const appliedEvents = (await api.getAppliedEvents()).data;

      const firstEventPartipant = appliedEvents.find(e => e.event.id === firstEventId && e.status !== 'PENDING');
      const secondEventPartipant = appliedEvents.find(e => e.event.id === secondEventId && e.status !== 'PENDING');

      const firstEventPrized = firstEventPartipant ? ['WON', 'WON_PRIZED', 'LOST'].includes(firstEventPartipant.status) : false;
      const secondEventPrized = secondEventPartipant ? ['WON', 'WON_PRIZED', 'LOST'].includes(secondEventPartipant.status) : false;

      const eventId = isFirstEvent ? firstEventId : secondEventId;
      const eventParticipant = isFirstEvent ? firstEventPartipant : secondEventPartipant;
      const eventPrized = isFirstEvent ? firstEventPrized : secondEventPrized;

      if (eventParticipant) {
        // 이벤트 응모 후 이미 당첨 또는 낙첨되었을 경우
        if (eventPrized) {
          onModal({
            title: '이벤트 안내',
            content: (<ModalText>이미 참여한 이벤트입니다</ModalText>),
          });
        } else {
          // 이벤트 응모가 되어 있는 경우 이후 절차로 pass
          afterEventApplied(eventParticipant.id);
        }
        return;
      }

      // 로그인 된 사용자의 페이백 가능한 주문 확인 (결제 완료, 배송비 및 환불 금액 제외 0원 이상, 결제 후 1년 이내)
      const paymentValidFromTime = new Date().setFullYear(new Date().getFullYear() - 1);
      const currentUserOrders = (await api.getCurrentUserOrder()).data;
      const validOrders = currentUserOrders.filter(order => 
        order.status === 'PAID' && order.finalPrice - order.finalShippingFee - order.refundAmount > 0
        && Date.parse(order.paymentCompleteTime) > paymentValidFromTime
      ).sort((a, b) => Date.parse(b.createDateTime) - Date.parse(a.createDateTime));

      // 페이백 가능한 주문이 없는 경우
      if (validOrders.length === 0) {
        onModal({
          title: '베이비페이스 결제 안내',
          content: (<ModalText>본 이벤트는 베이비페이스를 결제한 고객만 참여할 수 
            있습니다. 아직 베이비페이스를 결제하지 않으셨다면 결제 후 이벤트에 참여해 주세요.</ModalText>),
          buttonText: '베이비페이스 구매하기',
          afterConfirmEvent: () => history.push(PATH.SALES),
        });
        return;
      } 

      // 페이백 금액 확인 및 안내
      // 페이백 정책 : 1차, 2차 각 베이비페이스 베이직 금액 (배송비 제외)의 50% (최대 17,500원)
      const paybackOrder = validOrders[0];
      const orderAmount = paybackOrder.finalPrice;
      const paybackableAmount = paybackOrder.finalPrice - paybackOrder.finalShippingFee - paybackOrder.refundAmount;

      const firstPayback = Math.min(secondEventPrized ? paybackableAmount : paybackableAmount / 2, 17500);
      const secondPayback = Math.min(firstEventPrized ? paybackableAmount : paybackableAmount / 2, 17500);

      // 이벤트 정보 팝업 표시
      setConsentChecked(false);
      onModal({
        title: '이벤트 참여를 위한 필수 입력 정보 확인',
        content: (
          <ModalText size={12}>
            베이비페이스 결제 정보를 확인해 드립니다<br />
            <UnorderedList>
              <List>성명 : {name}</List>
              <List>휴대폰 번호 : {mobile.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)}</List>
              <List>베이비페이스 결제 금액: {orderAmount.toLocaleString()} 원</List>
              <List>환불 예정 금액: </List>
              {isFirstEvent && <IndentedList>부모 계좌 개설 시: {firstPayback.toLocaleString()} 원</IndentedList>}
              <IndentedList>자녀 계좌 개설 시: {secondPayback.toLocaleString()} 원</IndentedList>
            </UnorderedList>
            입력하신 정보가 미래에셋증권에 전달되어 자녀 계좌 개설 및 혜택 제공에 사용됩니다.<br />
            {isFirstEvent ? '성명과 휴대폰 번호는 미래에셋증권 가입시 개인정보와 동일해야 합니다.' : '성명과 휴대폰 번호는 미래에셋증권 자녀 계좌 개설시 입력한 법정대리인 정보와 일치해야 합니다. (위 성명, 휴대폰번호의 부모님께서 자녀 계좌 개설을 진행해야 합니다)'} 변경이 필요한 경우 "<LinkText style={{fontSize: '0.75rem'}} onClick={toUserInfo}>계정관리 (새창)</LinkText>"에서 수정해 주세요.<br />
            <h6 style={{ margin: '1rem 0', textAlign: 'center' }}>개인정보 수집 이용 동의 안내</h6>
            <ol>
              <List>수집 항목: 성명, 휴대폰 번호</List>
              <List>수집 및 이용 목적: 이벤트 혜택 제공, 고객 문의 응대</List>
              <List>보유 및 이용 기간: 이벤트 종료 후 6개월까지</List>
              <List>제공처: 미래에셋증권</List>
            </ol>
            <ConsentCheckbox 
              onClick={setConsentChecked}
              checked={false}
              text="개인정보 수집, 이용, 제공에 동의합니다. (필수)" />
          </ModalText>),
        buttonText: isFirstEvent ? '신규 부모 계좌 개설' : '자녀 첫 계좌 이벤트 신청',
        afterConfirmEvent: async () => {
          try {
            const eventParticipant = (await api.applyEvent({ 
              eventId, 
              status: 'APPLIED', 
              orderInfoId: paybackOrder.id
            })).data;
            afterEventApplied(eventParticipant.id);
          } catch (err) {
            console.error(err);
            onModal({
              title: '에러',
              content: (<ModalText>이벤트 응모 중 에러가 발생하였습니다. 잠시 후 다시 시도해 주시기 바랍니다.</ModalText>),
            });
          }
        },
      });
      setIsButtonAvailable(false);
    } catch (err) {
      console.error(err);
      onModal({
        title: '에러',
        content: (<ModalText>로딩 중 에러가 발생하였습니다. 잠시 후 다시 시도해 주시기 바랍니다.</ModalText>),
      });
    }
  }

  const EVENT_DETAIL_MIRAEASSET = {
    title: EVENT.TITLE_MIRAEASSET,
    period: EVENT.PERIOD_MIRAEASSET,
    images: IMAGE.EVENT_DETAIL_MIRAEASSET,
    buttons: [
      {
        image: IMAGE.EVENT_DETAIL_MIRAEASSET_BUTTONS[0],
        position: { top: '30.25%' },
        event: { type: 'action', onClick: onClickEventButton.bind(this, true) },
      },
      {
        image: IMAGE.EVENT_DETAIL_MIRAEASSET_BUTTONS[1],
        position: { top: '36.5%' },
        event: { type: 'action', onClick: onClickEventButton.bind(this, false) },
      },
    ],
  };

  return <EventDetailTemplateWithButtons
    event={EVENT_DETAIL_MIRAEASSET}
  />;
};

const ModalText = styled(Text)`
  line-height: 1.5;
  white-space: pre-line;
`;

const LinkText = styled.span`
  color: royalblue;
  font-weight: bold;
  cursor: pointer;
`

const List = styled.li`
  font-size: 0.75rem;
  text-align: left;
`

const IndentedList = styled(List)`
  margin-left: 1rem;
`

const UnorderedList = styled.ul`
  font-size: 0.75rem;
  text-align: left;
  border: 2px solid brown;
  border-radius: 1rem;
  padding: 0.5rem 1.5rem;
`

export default EventMiraeAssetDetailPage;
